import {
  createPrivateSerieAttendance,
  createPrivateSerieAttendanceVariables,
  privateSerieAttendance,
  privateSerieAttendanceVariables,
  privateSerieAttendancesForDay,
  privateSerieAttendancesForDayVariables,
  updatePrivateSerieAttendance,
  updatePrivateSerieAttendanceVariables,
} from "#types/code-generator.ts";
import type { TypedDocumentNode } from "#types/graphql.d.ts";
import { gql } from "graphql-tag";

export const PrivateSerieAttendancePayload = gql`
  fragment PrivateSerieAttendancePayload on PrivateSerieAttendance {
    atAccountHome
    automated
    completedBy {
      id
      firstName
      lastName
    }
    completedOn
    createdAt
    date
    duration
    id
    instructor {
      id
      firstName
      lastName
    }
    invoiceItems {
      id
      amount
      payments {
        id
        amount
      }
    }
    location {
      id
      title
      address1
    }
    note
    number
    privateSerie {
      id
      accountOwner {
        id
        firstName
        lastName
        phone
        email
      }
      instructor {
        id
        firstName
        lastName
      }
      numberOfLessons
      offering {
        id
        department {
          id
          title
        }
        duration
        participantType
        paymentFrequency
        program {
          id
          title
        }
        title
        type
      }
      roster {
        id
        firstName
        lastName
        gender
        healthConcerns
        healthQuestionResponses {
          id
          response
          healthQuestion {
            id
            slug
          }
        }
        birthDate
        note
      }
    }
    scheduledBy {
      id
      firstName
      lastName
    }
    scheduledOn
    status
    studentsAdded {
      id
      birthDate
      firstName
      gender
      lastName
    }
    studentsAttended {
      id
      firstName
      lastName
    }
    time
    updatedAt
    verifiedBy {
      id
      firstName
      lastName
    }
    verifiedOn
    zone {
      id
      title
    }
  }
`;

export const UpdatePrivateSerieAttendanceMutation = gql`
  mutation updatePrivateSerieAttendance(
    $data: PrivateSerieAttendanceCreateInput!
    $where: UniqueInput!
  ) {
    updatePrivateSerieAttendance(data: $data, where: $where) {
      ...PrivateSerieAttendancePayload
    }
  }
  ${PrivateSerieAttendancePayload}
` as TypedDocumentNode<
  updatePrivateSerieAttendance,
  updatePrivateSerieAttendanceVariables
>;

export const CreatePrivateSerieAttendanceMutation = gql`
  mutation createPrivateSerieAttendance(
    $data: PrivateSerieAttendanceCreateInput!
  ) {
    createPrivateSerieAttendance(data: $data) {
      ...PrivateSerieAttendancePayload
    }
  }
  ${PrivateSerieAttendancePayload}
` as TypedDocumentNode<
  createPrivateSerieAttendance,
  createPrivateSerieAttendanceVariables
>;

export const PrivateSerieAttendancesForDay = gql`
  query privateSerieAttendancesForDay(
    $date: Date!
    $organizationId: String!
    $filter: String
    $id: StringFilter
  ) {
    privateSerieAttendances(
      where: {
        date: { equals: $date }
        organizationId: $organizationId
        status: { notIn: [Canceled, Pending] }
        id: $id
      }
      filter: $filter
    ) {
      ...PrivateSerieAttendancePayload
    }
  }
  ${PrivateSerieAttendancePayload}
` as TypedDocumentNode<
  privateSerieAttendancesForDay,
  privateSerieAttendancesForDayVariables
>;

export const PrivateSerieAttendanceQuery = gql`
  query privateSerieAttendance($where: UniqueInput!) {
    privateSerieAttendance(where: $where) {
      ...PrivateSerieAttendancePayload
    }
  }
  ${PrivateSerieAttendancePayload}
` as TypedDocumentNode<privateSerieAttendance, privateSerieAttendanceVariables>;
